module.exports = __webpack_public_path__ + "static/media/powerLines.ced8bf15.jpg";